var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('xolas-table',{attrs:{"table-ref":"utilrpttable","title":_vm.utilLabel + ' Bill Report',"icon":"fa fa-plug","url":"/report/utility/summary","fields":_vm.fields,"sort-field":"siteName","show-refresh":false,"show-search":false,"layer-component":_vm.isTowerCo() ? 'utilityReport' : null,"layer-args":{ id: 'id' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }